/**
 * Stream Chat session — fetch token from our Worker, connect client.
 */
import { api } from '../../lib/api.js';

export type ChatTokenResponse = {
  apiKey: string;
  token: string;
  userId: string;
  name: string;
  image: string | null;
  role?: string;
};

export type ChatDirectoryUser = {
  id: string;
  name: string;
  role: string;
  image?: string | null;
};

export async function fetchChatToken(): Promise<ChatTokenResponse> {
  return api.get<ChatTokenResponse>('/api/chat/token');
}

export async function syncChatUsers(): Promise<{
  ok: boolean;
  synced: number;
  channels?: string[];
}> {
  return api.post<{ ok: boolean; synced: number; channels?: string[] }>('/api/chat/sync-users');
}

export async function archiveStaleChannels(olderThanDays = 90): Promise<{
  ok: boolean;
  archived: string[];
  scanned: number;
}> {
  return api.post<{ ok: boolean; archived: string[]; scanned: number }>(
    '/api/chat/archive-stale',
    { olderThanDays },
  );
}

export async function fetchChatDirectory(): Promise<{ items: ChatDirectoryUser[] }> {
  return api.get<{ items: ChatDirectoryUser[] }>('/api/chat/directory');
}
